import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeWhile, finalize } from 'rxjs';

import { IProfile, ProfilesService } from '@app/core/profiles';

@Component({
  selector: 'app-profile-dialog',
  templateUrl: './profile-dialog.component.html',
})
export class ProfileDialogComponent {
  public form: FormGroup;
  public saving: boolean;

  private destroyed: boolean;
  private profile: IProfile;

  constructor(
    cfg: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private service: ProfilesService
  ) {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      key: new FormControl('', [Validators.required]),
      isDefault: new FormControl(false),
      applicationId: new FormControl(''),
    });

    if (cfg.data?.profile) {
      this.profile = cfg.data.profile;
      this.form.patchValue({
        ...this.profile,
        isDefault: this.profile.isDefault ? true : false,
      });
    }
  }

  public saveChanges(): void {
    this.form.markAllAsTouched();

    Object.keys(this.form.controls).forEach((key) => {
      this.form.get(key).markAsDirty();
    });

    if (!this.form.valid) {
      return;
    }

    this.saving = true;

    const op = !this.profile
      ? this.service.createProfile({ ...this.form.value })
      : this.service.updateProfile({ ...this.profile, ...this.form.value });

    op.pipe(
      takeWhile(() => !this.destroyed),
      finalize(() => (this.saving = false))
    ).subscribe((panel) => {
      this.dialogRef.close(panel);
    });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }

  // Método para convertir el valor del campo de entrada a mayúsculas y reemplazar los espacios por guiones bajos
  transformarValor() {
    const valorActual = this.form.get('key').value;
    const nuevoValor = valorActual.toUpperCase().replace(/\s+/g, '_');
    this.form.get('key').setValue(nuevoValor);
  }
}
